import {NgModule} from '@angular/core';
import {CommonInvestSectionsComponent} from './common-invest-sections.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CoreTeamSectionModule} from '../../common/core-team-section/core-team-section.module';
import {WeHaveBeenInTheNewsModule} from '../../common/we-have-been-in-the-news/we-have-been-in-the-news.module';
import {AwardsAndAccreditationsModule} from '../../common/awards-and-accreditations/awards-and-accreditations.module';
import {MatButtonModule} from '@angular/material';

@NgModule({
    declarations: [CommonInvestSectionsComponent],
    imports: [CommonModule, RouterModule, CoreTeamSectionModule, WeHaveBeenInTheNewsModule, AwardsAndAccreditationsModule, MatButtonModule],
    exports: [CommonInvestSectionsComponent]
})
export class CommonInvestSectionsModule {
}
